import { useTranslation } from "react-i18next";
import { IncomePageType } from "../../../../constans";
import useAxios from "../../../../hooks/useAxios";
import { IGetIncome } from "../../../../models/financials.model";
import { getIncome, updateIncome } from "../../../../api/financials.api";
import useNotification from "../../../../hooks/useNotification";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import { useEffect, useRef, useState } from "react";
import { ITreeCode, ITreeSubcode } from "../../../../models/treeCodes.model";
import ErrorResponse from "../../../ErrorResponse";
import { DatePicker, Select } from "antd";
import moment from "moment";
import FileUpload from "../../../FileUpload";
import Button from "../../../Button";
import _ from "lodash";
import { CgCloseR } from "react-icons/cg";
import { IResponse } from "../../../../models/common.api.model";

interface IProps {
    getIncomeList: (listType: 'A' | 'P') => void;
    incomeCode: number,
    commonCode: string,
    setPageType: (param: IncomePageType) => void;
}

const IncomeEdit = ({incomeCode, commonCode, getIncomeList, setPageType} : IProps) => {

    const { t, i18n } = useTranslation();

    const { data: incomeDetail, isLoading, error, execute: executeDetail } = useAxios<IGetIncome>();
    const { data: editResult, isLoading : loading1 , error : editError, execute: executeSave } = useAxios<IResponse<Number>>();

    const { infoNotification, successNotification, errorNotification } = useNotification();
    const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
    const { treeCodes } = useSelector((state: RootState) => state.treeCodeData);
    // FA0002 = 수입 코드
    const FA0002 = treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 1));
    
    const { commonCodes } = useSelector((state: RootState) => state.commonCode);
    // FB0002 = 입금방법
    const FB0002 = commonCodes.find(item => item.commonCode === 'FB0002')?.detailCode;
    // FB0003 = 입금여부
    const FB0003 = commonCodes.find(item => item.commonCode === 'FB0003')?.detailCode;
    // FB0004 = 통화
    const FB0004 = commonCodes.find(item => item.commonCode === 'FB0004')?.detailCode;

    const [account1, setAccount1] = useState<string>();
    const [account2, setAccount2] = useState<string>();
    const [account3, setAccount3] = useState<string>();
    const [account2List, setAccount2List] = useState<ITreeSubcode[]>();
    const [account3List, setAccount3List] = useState<ITreeSubcode[]>();

    const [incomeDate, setIncomeDate] = useState('');   //입금일
    const [incomeMtd, setIncomeMtd] = useState("ON"); //입금방법
    const [incomeYn, setIncomeYn] = useState("Y");   //입금여부
    const [incomeDesc, setIncomeDesc] = useState('');   //내역
    const [currency, setCurrency] = useState("KRW");    //x통화
    const [amount, setAmount] = useState(0);    //입금액
    const [note, setNote] = useState('');   //비고
    // 신규 첨부파일
    const [files, setFiles] = useState<any>([null]);
    // 수정 시 기존 첨부파일
    const [fileinfo, setFileinfo] = useState<any>([null]);
    const dateArea = useRef<any>();

    useEffect(() => {
        getIncomeDetail();
    }, [incomeCode]);

    useEffect(() => {
        //조회되면 값 셋팅
        if(incomeDetail?.data) {
            setAccount1(incomeDetail.data.firstIncomeAccCode);
            setAccount2(incomeDetail.data.secondIncomeAccCode);
            setAccount3(incomeDetail.data.thirdIncomeAccCode);
            setAccount2List(treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 2 && item.parentDetailCode === Number(incomeDetail.data.firstIncomeAccCode) )))
            setAccount3List(treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 3 && item.parentDetailCode === Number(incomeDetail.data.secondIncomeAccCode) )))
            setIncomeDate(incomeDetail.data.incomeDate);
            setIncomeMtd(incomeDetail.data.incomeMtd);
            setIncomeYn(incomeDetail.data.incomeYn);
            setIncomeDesc(incomeDetail.data.incomeDesc);
            setCurrency(incomeDetail.data.currency);
            setAmount(incomeDetail.data.amount);
            setNote(incomeDetail.data.note);
            setFileinfo(_.cloneDeep(incomeDetail.data.files));
        }
    }, [incomeDetail]);

    useEffect(() => {
        if(editResult) {
            if(editResult.result === "success") {
                successNotification(t('common.message.save1'));
                //리스트페이지 검색조건으로 재검색
                getIncomeList('A');
                //조회페이지로 변경
                setPageType(IncomePageType.VIEW);
            }
        }

    }, [editResult]);

    useEffect(() => {
        if(editError) {
            if (!editError?.response?.status) return;
            if(editError.response?.data.data === 'CC') {
                errorNotification(t('payment.income.error1'));
            } else {
                errorNotification(t('common.message.error'));
            }
        }
    }, [editError]);

    const getIncomeDetail = () => {
        executeDetail(getIncome(incomeCode, commonCode));
    }

    const firstAccountChange = (value : any) => {
        setAccount1(value);
        if(value) {
            setAccount2List(treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 2 && item.parentDetailCode === Number(value) )))
            setAccount3List(undefined);
            setAccount2(undefined);
            setAccount3(undefined);
        }
    }

    const secondAccountChange = (value : any) => {
        setAccount2(value);
        if(value) {
            setAccount3(undefined);
            setAccount3List(treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 3 && item.parentDetailCode === Number(value) )));
        }
    }

    const onSetFile = (index: number, file: any) => {
        const _files = [...files];
        _files[index] = file;
        setFiles(_files);
    }
    
    const onAddFile = () => {
        const _files = [...files];
        _files.push(null);
        setFiles(_files);
    }
    
    const onDeleteFile = (index: number) => {
        const _files = [...files];
        _files.splice(index, 1);
        setFiles(_files);
    }

    const onDeleteAttachedFile = (index: number) => {
        const _fileinfo = [...fileinfo];
        _fileinfo[index].originalName = null;
        setFileinfo(_fileinfo);
    }
    
    const onSave = async () => {
        if(!account3) {
            return infoNotification(t('payment.income.msg2'));
        }

        if(!incomeDate) {            
            return infoNotification(t('payment.income.msg3'));
        }
        /*
        if(!incomeDesc) {            
            return infoNotification(t('payment.income.msg4'));
        }
        */
        if(!amount) {            
            return infoNotification(t('payment.income.msg5'));
        }

        //파라미터 셋팅(form?)
        const form = new FormData();
        form.append('incomeAccCode', account3.toString());
        form.append('incomeDate', incomeDate);
        form.append('incomeMtd', incomeMtd);
        form.append('incomeYn', incomeYn);
        form.append('incomeDesc', incomeDesc);
        form.append('currency', currency);
        form.append('amount', amount.toString());
        form.append('note', note);

        // 파일 처리
        if (incomeDetail?.data?.attachFileCode) {
            form.append('attachFileCode', incomeDetail?.data?.attachFileCode);
        }

        if (fileinfo) {
            // 기존 첨부파일 있음
            let hasNewFiles = false;
            files.forEach((item: any) => {
            if (item) hasNewFiles = true;
            });

            let isAllDeleted = true;
            let hasDeleted = false;
            fileinfo.forEach((item: any) => {
            if (item.originalName) {
                isAllDeleted = false;
            } else {
                hasDeleted = true;
                form.append('deleteFiles', item.fileSeq);
            }
            });

            if (hasNewFiles) form.append('fileStatus', 'update');
            else if (isAllDeleted) form.append('fileStatus', 'delete');
            else if (hasDeleted) form.append('fileStatus', 'update');
            else form.append('fileStatus', 'keep');
        } else {
            // 기존 첨부파일 없음
            if (files.length > 0 && files[0] !== null) {
            // 추가 첨부파일 있음
            form.append('fileStatus', 'create');
            } else {
            // 추가 첨부파일 없음
            form.append('fileStatus', 'keep');
            }
        }

        if (files.length > 0) {
            files.forEach((item: any) => {
                if (item !== null) form.append('newFiles', item);
            });
        }

        executeSave(updateIncome(incomeCode, form));
    }

    return(
        <>
            <ErrorResponse error={error} />
            <div className="comm-bx__between">  
                <h3 className='sub-title'>{t('payment.income.title4')}</h3>
            </div>
            <div className="comm-table__area rowType">
                <table>
                    <colgroup>
                        <col width="15%" />
                        <col width="85%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>{t('system.treecode.account1')}</th>
                            <td>
                                <Select
                                    placeholder={t('payment.income.search2') + ' ' + t('campus.staff.placeholder2')}
                                    className="w-240p"
                                    value={account1}
                                    onChange={(value)=>{
                                        firstAccountChange(value);
                                    }}
                                >
                                    {
                                        FA0002?.map((item : ITreeCode)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode.toString()}
                                                    value={item.detailCode.toString()}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('system.treecode.account2')}</th>
                            <td>
                                <Select
                                    placeholder={t('payment.income.search2') + ' ' + t('campus.staff.placeholder2')}
                                    className="w-240p"
                                    value={account2}
                                    onChange={(value)=>{
                                        secondAccountChange(value);
                                    }}
                                >
                                    {
                                        account2List?.map((item : ITreeCode)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode.toString()}
                                                    value={item.detailCode.toString()}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('system.treecode.account3')}</th>
                            <td>
                                <Select
                                    placeholder={t('payment.income.search2') + ' ' + t('campus.staff.placeholder2')}
                                    className="w-240p"
                                    value={account3}
                                    onChange={(value)=>{
                                        setAccount3(value);
                                    }}
                                >
                                    {
                                        account3List?.map((item : ITreeCode)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode.toString()}
                                                    value={item.detailCode.toString()}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div ref={dateArea} ></div>
            <div className="comm-table__area rowType">
                <table>
                    <colgroup>
                        <col width="15%" />
                        <col width="35%" />
                        <col width="15%" />
                        <col width="35%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>{t('student.student.62')}</th>
                            <td>{moment(incomeDetail?.data?.registDate).format("YYYY-MM-DD")}</td>
                            <th>{'* ' + t('payment.income.column1')}</th>
                            <td>
                                <div className="date-picker__area">
                                    <DatePicker
                                        value={incomeDate ? moment(incomeDate) : undefined}
                                        onChange={e => {
                                            if (e === null) setIncomeDate('');
                                            else setIncomeDate(moment(e).format('YYYYMMDD'))
                                        }}
                                        format={['YYYY-MM-DD', 'YYYYMMDD']}
                                        getPopupContainer={() => {
                                            return dateArea.current as HTMLElement;
                                        }}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{'* ' + t('payment.income.search3')}</th>
                            <td>
                                <Select
                                    className="w-100"
                                    value={incomeMtd}
                                    onChange={(value)=>{
                                        setIncomeMtd(value);
                                    }}
                                >
                                    {
                                        FB0002?.map((item)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode}
                                                    value={item.detailCode}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                            <th>{'* ' + t('payment.income.search4')}</th>
                            <td>
                                <Select
                                    className="w-100"
                                    value={incomeYn}
                                    onChange={(value)=>{
                                        setIncomeYn(value);
                                    }}
                                >
                                    {
                                        FB0003?.map((item)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode}
                                                    value={item.detailCode}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                        </tr>
                        <tr>
                            <th>{'* ' + t('payment.income.column4')}</th>
                            <td colSpan={3}>
                                <div className="flex" style={{alignItems:'center', gap:'5px'}}>
                                    <Select
                                        className="w-120p text-center"
                                        value={currency}
                                        onChange={(value)=>{
                                            setCurrency(value);
                                        }}
                                    >
                                        {FB0004?.map((item) => {
                                            return(
                                                <Select.Option
                                                    key={item.detailCode}
                                                    value={item.detailCode}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })};
                                    </Select>
                                    <input
                                        type="number"
                                        className="form-control input-text text-right w-210p"
                                        value={amount.toString()}
                                        onChange={e => {
                                            if(Number(e.target.value) < 0) {
                                                return false;
                                            }
                                            setAmount(Number(e.target.value))
                                        }}
                                    />
                                    <b>{t('campus.setting.text2')}</b>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('payment.income.search5')}</th>
                            <td colSpan={3}>
                                <div className="w-100">
                                    <input
                                        type="text"
                                        className="form-control input-text"
                                        value={incomeDesc}
                                        onChange={e => setIncomeDesc(e.target.value)}
                                    />
                                </div>
                            </td>
                        </tr>
                        {
                            incomeDetail?.data && fileinfo
                            ? (
                                <tr>
                                    <th>{t('archive.learn.column5')}</th>
                                    <td colSpan={3}>
                                        {
                                        fileinfo.map((item: any, index: number) => {
                                            const result = item?.originalName
                                            ? (
                                                <div key={index}>
                                                <a
                                                    className="download-link"
                                                    href={`${item.fileLocation}`}
                                                    download={item.originalName}
                                                >
                                                    {item.originalName}
                                                </a>
                                                <span
                                                    className="ml-1 pointer"
                                                    onClick={() => onDeleteAttachedFile(index)}
                                                >
                                                    <CgCloseR />
                                                </span>
                                                </div>
                                            )
                                            : null;
                                            return result;
                                        })
                                        }
                                    </td>
                                </tr>
                                )
                            : null
                        }
                        <tr>
                            <th>{incomeDetail?.data && fileinfo ? t('archive.learn.column6') : t('common.column.file')}</th>
                            <td colSpan={3}>
                                {files.map((file: any, index: number) => (
                                    <div className="flex mb-2" key={index}>
                                        <FileUpload
                                        file={files[index]}
                                        setFile={(file: any) => onSetFile(index, file)}
                                        />
                                        <div className="comm-btn__area">
                                            <Button
                                                className="btn-basic small gray ml-2"
                                                onClick={() => onDeleteFile(index)}
                                                text={t('common.button.delete')}
                                            />
                                        </div>
                                    </div>
                                ))}
                                <div className="comm-btn__area">
                                    <Button
                                        className="btn-basic pink-line"
                                        onClick={onAddFile}
                                        text={t('common.button.add')}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('common.text.note')}</th>
                            <td colSpan={3}>
                                <textarea
                                    className="w-100"
                                    rows={5}
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="comm-bx__between">
                <div></div>
                <div className="comm-btn__area">
                    <Button
                        onClick={onSave}
                        className="btn-basic pink"
                        text={t('common.button.save')}
                        /*writeAuthYn={writeAuthYn}*/
                    />
                </div>
            </div>
            
        </>
    )
}

export default IncomeEdit;